// src/pages/PrivacyPage.js

import React from 'react';
import PrivacySection from '../components/PrivacySection'; // Ensure this component exists if you need specific content
import '../style.css';

function PrivacyPage() {
  return (
    <div>
      <PrivacySection /> {/* or content directly here if PrivacySection isn't used */}
    </div>
  );
}

export default PrivacyPage;
